import React from "react";
import './searchBar.css';


function SearchBar({data,handleClick,tipo}){
    return (
        <div className="dataResult">
            {data.map(value => (
                <div key={value.id} className="dataItem" onClick={() => handleClick(value)}>
                    {tipo == "turma" && (<p>{value.nometurma}</p>)}
                    {tipo == "aluno" && (<p>{value.aluno}</p>)}
                    {tipo == "filial" && (<p>{value.nomefilial}</p>)}
                    {tipo == "porteiro" && (<p>{value.nomeporteiro}</p>)}
                    {tipo == "responsavel" && (<p>{value.nomeres}</p>)}
                    {tipo == "nomealuno" && (<p>{value.nomealuno}</p>)}
                </div>
            ))}
        
        </div>
    )
}

export default SearchBar;